import appConfig from "../config/app-config";
const { IMAGE_PATH, API_URL } = appConfig;

const validarCPF = inputCPF => {
  let cpf = inputCPF;
  let add;
  let i;
  let rev;
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf === '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false;
  // Valida 1o digito
  add = 0;
  for (i = 0; i < 9; i++) add += parseInt(cpf.charAt(i), 10) * (10 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(9), 10)) return false;
  // Valida 2o digito
  add = 0;
  for (i = 0; i < 10; i++) add += parseInt(cpf.charAt(i), 10) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpf.charAt(10), 10)) return false;
  return true;
};



/*
 validaCnpj
 
 Valida se for um CNPJ
 
 @param string cnpj
 @return bool true para CNPJ correto
*/
function validaCnpj(vlr) {

  const cnpj = vlr.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== 14)
    return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj === parseInt("00000000000000", 10) ||
    cnpj === parseInt("11111111111111", 10) ||
    cnpj === parseInt("22222222222222", 10) ||
    cnpj === parseInt("33333333333333", 10) ||
    cnpj === parseInt("44444444444444", 10) ||
    cnpj === parseInt("55555555555555", 10) ||
    cnpj === parseInt("66666666666666", 10) ||
    cnpj === parseInt("77777777777777", 10) ||
    cnpj === parseInt("88888888888888", 10) ||
    cnpj === parseInt("99999999999999", 10))
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(0), 10)) {
    console.log(resultado, digitos.charAt(0))
    return false;
  }


  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(1), 10)) {
    console.log("zebra")
    return false;
  }

  return true;

} // validaCnpj


// function forceDownloadAsync(url){
//   return new Promise( (resolve, reject) => {
//       var image = new Image()
//       image.src = url
//       image.onload = () => resolve(image)
//       image.onerror = () => reject(new Error('could not load image'))
//   })
// }    

function forceDownloadAsync(img){
  console.log(img);
  
  return new Promise( (resolve, reject) => {
    const LINK = document.createElement('a');
    let url = IMAGE_PATH + img;
    let finalUrl = `${API_URL}/Dashboard/forcedownload?file=${encodeURIComponent(url.replace(IMAGE_PATH, ""))}`;
    
    LINK.href = finalUrl;
    const evt = new MouseEvent('click', {
      'view': window,
      'bubbles': true,
      'cancelable': false
    });
    
    LINK.setAttribute('href', LINK.href);
    LINK.setAttribute('download', '');
    LINK.setAttribute('target', '_blank');
    LINK.dispatchEvent(evt);

    // image.onload = () => resolve(image)
    // image.onerror = () => reject(new Error('could not downloadload image'))
  })
}

// possivel função errada, criada fora do componente - lucas leme de moura 
function forceDownload(url, force) {
  let link = document.createElement('a');
  // const fileName = url.substring(url.lastIndexOf('/') + 1, url.length).replace(/^[0-9]{14}-/gm, "");
  // const finalUrl = `${API_URL.replace(/^https:/, "http:")}/Dashboard/${force ? 'forcedownload' : 'download'}?file=${encodeURIComponent(url.replace(IMAGE_PATH, ""))}`;
  // const finalUrl = `${API_URL}/Dashboard/${force ? 'forcedownload' : 'download'}?file=${encodeURIComponent(url.replace(IMAGE_PATH, ""))}`;
  let finalUrl = `${API_URL}/Dashboard/forcedownload?file=${encodeURIComponent(url.replace(IMAGE_PATH, ""))}`;
  // console.log(finalUrl);
  try {
    link.href = finalUrl;
    // link.download = fileName;
    link.target = "_blank";
    const evt = new MouseEvent('click', {
      'view': window,
      'bubbles': true,
      'cancelable': false
    });
    document.body.appendChild(link);

    link.dispatchEvent(evt);
    document.body.removeChild(link);

    (window.URL || window.webkitURL).revokeObjectURL(link.href);

  } catch (ex) {

    /*
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Arquivo.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    */
    console.log(`erro download: ${ex}`);
    document.location = finalUrl;
  }
}

export default validarCPF;
export { validarCPF, validaCnpj, forceDownload, forceDownloadAsync };



// WEBPACK FOOTER //
// ./src/lib/validations.js